var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import a from "axios";
import { onGetSubOrdersFailure, onGetSubOrdersSuccess, } from "../../OrderFlow/components/SubscriptionSummaryPage/SubscriptionSummaryPage-utils";
import { ERROR_MESSAGE_GENERIC } from "../../Shared/utils/constants";
import { axiosPrivate } from "../../api/axios";
export const buildErrorMessage = (error, altGenericErrorMessage) => {
    if (a.isAxiosError(error))
        return error.message;
    else if (altGenericErrorMessage)
        return altGenericErrorMessage;
    else
        return ERROR_MESSAGE_GENERIC;
};
export const doesPlaceChangeRequireReschedule = (orderId, locationSku, addressId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axiosPrivate.get("/Account/DoesPlaceChangeRequireReschedule", {
        params: {
            orderId: orderId,
            locationSku: locationSku,
            addressId: addressId,
        },
    });
    return {
        success: response.data.success,
        isAbleToBeModified: response.data.isAbleToBeModified,
        isPlaceUpdated: response.data.isPlaceUpdated,
        isRescheduleRequired: response.data.isRescheduleRequired,
        message: response.data.message,
    };
});
export const getRemappingInfo = (orderId, setOrderData) => {
    axiosPrivate
        .get("GetOrderInfo", {
        params: {
            orderId,
        },
    })
        .then((res) => {
        if (res && res.data) {
            setOrderData((prev) => (Object.assign(Object.assign({}, prev), { orderInfo: res.data.orderInfo, blockingCopy: res.data.blockingCopy, loading: false })));
        }
        else {
            setOrderData((prev) => (Object.assign(Object.assign({}, prev), { error: ERROR_MESSAGE_GENERIC, loading: false })));
        }
    })
        .catch((error) => {
        const errorMessage = buildErrorMessage(error);
        setOrderData((prev) => (Object.assign(Object.assign({}, prev), { error: errorMessage, loading: false })));
    });
};
/**
 * @param newZipCode
 * @param programSKU
 * @param locationSKU
 * @param onSuccess
 * @param onError
 */
export const getDeliveryScheduleID = (newZipCode, programSKU, order, locationSKU) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axiosPrivate.get(`/Account/GetDeliverySchedule`, {
        params: {
            zipcode: newZipCode,
            programSKU: programSKU,
            locationSKU: locationSKU,
        },
    });
    if (res.data.deliverySchedule !== order.deliverySchedule)
        return true;
    else
        return false;
});
/**
 * Update Address Modal: filter pickup locations by programId.
 * @param {*} locations All locations.
 * @param {*} programId Order program ID for which the locations are to be displayed.
 * @returns
 */
export const filterLocationsByProgramId = (locations, programId) => programId ? locations.filter((loc) => { var _a; return (_a = loc === null || loc === void 0 ? void 0 : loc.locationProgramIds) === null || _a === void 0 ? void 0 : _a.includes(programId); }) : locations;
/**
 * Gets data for update address modal.
 * @param {*} setState Save fetch results to state.
 * @param {*} programId Order program ID for the addresses.
 */
export const getSubscriptionOrdersLists = (subscriptionLinkId, setSubscriptionOrdersState, store, toast, datadogLog, closeEditModal) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axiosPrivate.get(`/Account/GetSubscriptionOrders`, {
            params: {
                subscriptionLinkId,
            },
        });
        onGetSubOrdersSuccess(setSubscriptionOrdersState, store, res);
    }
    catch (error) {
        console.error("Error fetching subscription orders:", error);
        onGetSubOrdersFailure(setSubscriptionOrdersState, toast, datadogLog, error, closeEditModal);
        throw error;
    }
});
